import React from 'react'
import PrimaryButton from 'core-system/Button/PrimaryButton'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import styled from 'styled-components'

const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 2.5rem 0;
  gap: 1.5rem;
`

interface LaunchButtonsProps {
  isFromUpdate: boolean
  editPrograms: () => void
  saveAsDraft: () => void
  isLaunchDisabled?: boolean
}

export const LaunchButtons = ({
  isFromUpdate,
  saveAsDraft,
  editPrograms,
  isLaunchDisabled = false,
}: LaunchButtonsProps) => {
  if (isFromUpdate) {
    return (
      <BottomContainer>
        <PrimaryButton onClick={editPrograms} disabled={isLaunchDisabled}>
          Update Programs
        </PrimaryButton>
      </BottomContainer>
    )
  }
  return (
    <BottomContainer>
      <PrimaryButton onClick={editPrograms} disabled={isLaunchDisabled}>
        Launch Programs
      </PrimaryButton>
      <SecondaryButton onClick={saveAsDraft}>Save Draft</SecondaryButton>
    </BottomContainer>
  )
}
